import { MessagingExecutionType } from './messagingExecutionType';
import { TriggerKey } from '../userCommunicationAgent';

export enum SlackFilterType {
  ALL = 'all',
  BY_CHANNEL = 'by_channel',
  BY_PERSON = 'by_person',
}

// Slack trigger configs

export interface SlackNewMessageWorkspaceScope {
  workspaceId: string;
  channels?: string[]; // empty/absent = all channels in this workspace
}

export interface SlackNewMessageTriggerConfig {
  executionType: MessagingExecutionType;
  workspaces?: SlackNewMessageWorkspaceScope[]; // empty/absent = all workspaces + all channels
}

export interface SlackChannelMatchTriggerConfig {
  channels: string[];
  executionType?: MessagingExecutionType;
  workspaceId?: string;
}

export interface SlackAuthorMatchTriggerConfig {
  authorIds: string[];
  executionType?: MessagingExecutionType;
  workspaceId?: string;
}

// Slack step configs

export interface SendSlackMessageStepConfig {
  workspaceId: string;
  channel: string;
  message: string;
}

export const SLACK_TRIGGER_KEYS = [
  TriggerKey.SLACK_NEW_MESSAGE,
  TriggerKey.SLACK_CHANNEL_MATCH,
  TriggerKey.SLACK_AUTHOR_MATCH,
];
